<script setup>
import Price from "@/Components/Price.vue";

defineProps(['product']);
</script>

<template>
    <template v-if="product.discount">
        <small><Price :value="product.stdPrice" :uom="product.uom.price" :sale="true" /><br /></small>
    </template>
    <template v-if="product.clearance">
        <Price :value="product.clearance.stdPrice" :uom="product.uom.price" :clearance="true"/><br />
    </template>
    <Price :value="product.price" :uom="product.uom.price" />
</template>
